import { queries } from '../common/api/queryKeys/queries';
import { usePaginationQuery } from '../common/hooks/usePaginationQuery';

export const useKeyPortPagination = ({ page, searchQuery, customerGroupIds }) => {
    return usePaginationQuery({
        queryKey: queries.keyPorts.pagination({ page, searchQuery, customerGroupIds }).queryKey,
        queryFn: queries.keyPorts.pagination({ page, searchQuery, customerGroupIds }).queryFn,
        options: { keepPreviousData: true },
        prefetchQueryKey: queries.keyPorts.pagination({
            page: page + 1,
            searchQuery,
            customerGroupIds,
        }).queryKey,
        prefetchQueryFn: queries.keyPorts.pagination({
            page: page + 1,
            searchQuery,
            customerGroupIds,
        }).queryFn,
    });
};
